var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcelHover = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.4688 10.625V15.625C15.4688 15.8906 15.2656 16.0938 15 16.0938H5C4.73438 16.0938 4.53125 15.8906 4.53125 15.625V10.625C4.53125 10.3594 4.73438 10.1562 5 10.1562H15C15.2656 10.1562 15.4688 10.3594 15.4688 10.625ZM11.25 11.0938H5.46875V12.6562H11.25V11.0938ZM11.25 13.5938H5.46875V15.1562H11.25V13.5938ZM14.5312 11.0938H12.1875V12.6562H14.5312V11.0938ZM14.5312 13.5938H12.1875V15.1562H14.5312V13.5938Z",
  fill: "#4637C0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3125 0.15625H15.625C16.75 0.15625 17.6562 1.0625 17.6562 2.1875V17.8125C17.6562 18.9375 16.75 19.8438 15.625 19.8438H4.375C3.25 19.8438 2.34375 18.9375 2.34375 17.8125V5.78125C2.34375 5.65625 2.39062 5.54688 2.48438 5.45312L7.64062 0.296875C7.76562 0.15625 7.96875 0.125 8.14062 0.1875C8.32812 0.265625 8.4375 0.4375 8.4375 0.625V4.21875C8.4375 5.34375 7.53125 6.25 6.40625 6.25H3.28125V17.8125C3.28125 18.4219 3.76562 18.9062 4.375 18.9062H15.625C16.2344 18.9062 16.7188 18.4219 16.7188 17.8125V2.1875C16.7188 1.57812 16.2344 1.09375 15.625 1.09375H10.3125C10.0469 1.09375 9.84375 0.890625 9.84375 0.625C9.84375 0.359375 10.0469 0.15625 10.3125 0.15625Z",
  fill: "#4637C0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcelHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel_hover.efeb3a1a3a5099817db343ff56b038ab.svg";